import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center" }
const _hoisted_2 = { class: "w-full h-full p-4 pb-0 max-h-screen flex flex-col md:flex-row md:items-center" }

import { 
  IonContent, 
  IonHeader, 
  IonPage, 
  IonImg, 
  IonToolbar, 
  menuController, 
  IonButtons, 
  IonButton,
  IonIcon, 
  loadingController,
  IonModal,
  IonRouterOutlet,
  alertController,
} from '@ionic/vue';
import axios from 'axios';
import { useCompany } from '@/store/company'
import { menu, add } from 'ionicons/icons';
import { onMounted, ref, } from 'vue';
import FilterModal from './../components/HomePage/FilterModal.vue'
import MenuView from './../components/HomePage/MenuView.vue'
import Filter from '@/interfaces/Filter';
import { useFilter } from '@/store/filter'
import ProjectList from '@/components/HomePage/ProjectList.vue';
import SearchArea from '@/components/HomePage/SearchArea.vue';
import { useCurrentUser } from '@/store/currentUser'



export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const filterStore = useFilter()
const companyStore = useCompany()
const currentUserStore = useCurrentUser()

const searchValue = ref("")
const projects = ref([] as any[])
const offset = ref(0)
const modalOpen = ref(false)

function filterModalClosedCheckIfItShouldSearchAgain(event: any) {
  if(event.detail.data)
    searchProject(true)
}

async function getProjectsFromApi(): Promise<any> {
  const filters: Filter[] = filterStore.filters
  const typeFilter = filters.find((item: Filter) => item.titel === 'Typ')
  const statusFilter = filters.find((item: Filter) => item.titel === 'Status')
  const resubmissionFilter = filters.find((item: Filter) => item.titel == 'Wiedervorlage')
  const offer_sum = filters.find((item: Filter) => item.titel == 'Angebotssumme')
  const tag = filters.find((item: Filter) => item.titel == 'Tags')
  const checkpoint = filters.find((item: Filter) => item.titel == 'Enthält Checkpoint')
  const missingCheckpoint = filters.find((item: Filter) => item.titel == 'Fehlender Checkpoint')
  const sales_user = filters.find((item: Filter) => item.titel == 'Vertrieb')
  const manager_user = filters.find((item: Filter) => item.titel == 'Projektleiter')
  const calculator = filters.find((item: Filter) => item.titel == 'Berechner')
  const team = filters.find((item: Filter) => item.titel == 'Team')
  
  return await axios.get(
    process.env.VUE_APP_PROJECT_API_BASE_URL + 'project?limit=40&offset=' + offset.value + 
    '&search=' + searchValue.value + 
    '&company=' + companyStore.activeCompany.id + 
    '&type=' + typeFilter?.value +
    '&status=' + statusFilter?.value +
    '&resubmission=' + resubmissionFilter?.value +
    '&offer_sum=' + offer_sum ?.value +
    '&tag=' + tag?.value +
    '&checkpoint=' + checkpoint?.value + 
    '&checkpoint!=' + missingCheckpoint?.value +
    '&sales_user=' + sales_user?.value +
    '&manager_user=' + manager_user?.value +
    '&calculator=' + calculator?.value +
    '&team=' + team?.value , {
    headers: {
      Authorization: 'Bearer ' + currentUserStore.jwtKey
    }
  })
}

async function searchProject(showLoadingPopUp: boolean) {
  const loading = await loadingController.create({
    message: 'Lade Projekte...',
  })

  if(showLoadingPopUp) {
    await loading.present();
  }
  offset.value = 0

  try {
    const response = await getProjectsFromApi()
    offset.value += 40
    projects.value = response.data.data
  } catch (e: any) {
    const alert = await alertController.create({
      message: 'Konnte keine Daten laden',
      buttons: ['OK']
    })
    await alert.present()
  } finally {
    if(showLoadingPopUp) {
      await loading.dismiss()
    }
  }
}  
    
async function loadProjects(event: any) {
  try {
    const response = await getProjectsFromApi()
    for(const project of response.data.data) {
      projects.value.push(project)
    }
    offset.value += 40
  } catch (e) { 
    const alert = await alertController.create({
      message: 'Konnte keine weiteren Daten laden',
      buttons: ['OK']
    })
    await alert.present()
  }
  event.target.complete()
}

function openMenu() {
  menuController.enable(true, 'homeMenu');
  menuController.open('homeMenu');
}

onMounted(async() => {
  await searchProject(true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(MenuView, {
        onLoadData: _cache[0] || (_cache[0] = ($event: any) => (searchProject(false)))
      }),
      (_ctx.$route.path == '/')
        ? (_openBlock(), _createBlock(_unref(IonRouterOutlet), {
            key: 0,
            id: "main"
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    id: "menuButton",
                    style: _normalizeStyle('--color: ' + _unref(companyStore).activeCompany.color),
                    onClick: openMenu
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(menu) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                (_unref(companyStore).activeCompany.color !== '#8915b0')
                  ? (_openBlock(), _createBlock(_unref(IonImg), {
                      key: 0,
                      id: "activeCompanyLogo",
                      class: "h-9",
                      src: './assets/icon/' + _unref(companyStore).activeCompany.id + '.png'
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "text-xl font-bold",
                      style: _normalizeStyle('color: ' + _unref(companyStore).activeCompany.color)
                    }, _toDisplayString(_unref(companyStore).activeCompany.name), 5))
              ]),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    style: _normalizeStyle('--color: ' + _unref(companyStore).activeCompany.color),
                    routerLink: "addProject"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(add) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonModal), {
            onWillDismiss: _cache[1] || (_cache[1] = ($event: any) => (modalOpen.value = false)),
            onDidDismiss: _cache[2] || (_cache[2] = ($event: any) => (filterModalClosedCheckIfItShouldSearchAgain($event))),
            "is-open": modalOpen.value,
            "presenting-element": _ctx.$parent!.$refs.ionRouterOutlet
          }, {
            default: _withCtx(() => [
              _createVNode(FilterModal)
            ]),
            _: 1
          }, 8, ["is-open", "presenting-element"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SearchArea, {
              "modal-open": modalOpen.value,
              onSetModalOpen: _cache[3] || (_cache[3] = (newModalOpenValue) => modalOpen.value = newModalOpenValue),
              onSearchProject: _cache[4] || (_cache[4] = (showLoading) => searchProject(showLoading)),
              onSearchValue: _cache[5] || (_cache[5] = (newSearchValue) => searchValue.value = newSearchValue)
            }, null, 8, ["modal-open"]),
            _createVNode(ProjectList, {
              onLoadProjects: _cache[6] || (_cache[6] = (event) => loadProjects(event)),
              onSearchProject: _cache[7] || (_cache[7] = (showLoading) => searchProject(showLoading)),
              projects: projects.value
            }, null, 8, ["projects"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})